import { z } from 'zod';
import './nullableDefault';
const blockNode = z.enum(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'ol', 'ul']);
const linkNode = z.literal('a');
const spanNode = z.literal('span');
const listItemNode = z.literal('li');
const fragmentNode = z.literal('fragment');
const textAlignStyle = z.object({
  'text-align': z.enum(['left', 'center', 'right', 'justify']).default('left')
});
export type BlockNodeType = z.infer<typeof blockNode>;

/** Mode React `Text` `setting` values — aligned with `@stitch-fix/mode-react` Text. */
export const MODE_TEXT_SETTINGS = ['title-xxlarge', 'title-xlarge', 'title-large', 'title-medium', 'title-small', 'title-xsmall', 'title-xxsmall', 'subtitle-medium', 'subtitle-small', 'eyebrow-medium', 'eyebrow-small', 'display-xlarge', 'display-large', 'display-medium', 'body-large', 'body-large-fixed', 'body-medium', 'body-medium-fixed', 'body-small', 'body-small-fixed', 'body-xsmall', 'body-xsmall-fixed'] as const;
export const modeTextSettingSchema = z.enum(MODE_TEXT_SETTINGS);
export type ModeTextSetting = z.infer<typeof modeTextSettingSchema>;
const childText = z.object({
  text: z.string(),
  break: z.boolean().optional(),
  bold: z.boolean().optional(),
  inlineCode: z.boolean().optional(),
  italic: z.boolean().optional(),
  underline: z.boolean().optional(),
  strikethrough: z.boolean().optional(),
  classname: z.string().optional(),
  modeTextSetting: modeTextSettingSchema.optional()
});
export type ChildText = z.infer<typeof childText>;
const childLink = z.object({
  type: linkNode,
  attrs: z.object({
    url: z.string(),
    target: z.string()
  }),
  uid: z.string(),
  children: z.array(childText)
});
export type ChildLink = z.infer<typeof childLink>;
const childSpan = z.object({
  type: spanNode,
  attrs: z.object({}),
  uid: z.string(),
  children: z.array(childText)
});
export type ChildSpan = z.infer<typeof childSpan>;
const childListItem = z.object({
  type: listItemNode,
  attrs: z.object({
    style: textAlignStyle.optional()
  }),
  uid: z.string(),
  children: z.array(childText)
});
export type ChildListItem = z.infer<typeof childListItem>;
const childFragment = z.object({
  type: fragmentNode,
  uid: z.string(),
  children: z.array(childText)
});
export type ChildFragment = z.infer<typeof childFragment>;
const childBlock = z.object({
  type: blockNode,
  attrs: z.object({
    style: textAlignStyle.optional(),
    'class-name': z.string().optional()
  }),
  uid: z.string(),
  children: z.array(z.union([childText, childLink, childSpan, childListItem]))
});
export type ChildBlock = z.infer<typeof childBlock>;
export const contentStackJSONRichText = z.object({
  uid: z.string().nullableDefault().default(''),
  _version: z.number().optional(),
  attrs: z.object({}).nullableDefault().default({}),
  children: z.array(z.union([childBlock, childFragment])).nullableDefault().default([]),
  type: z.literal('doc').nullableDefault().default('doc')
}).nullableDefault().default({
  uid: '',
  attrs: {},
  children: [],
  type: 'doc'
});
export type ContentStackJSONRichText = z.infer<typeof contentStackJSONRichText>;